const styles = (theme) => {
  const isDark = theme.palette.mode === 'dark';
  return {
  pageWrapper: {
    padding: "0",
    "& .ct-label": {
      color: isDark ? "rgba(255,255,255,0.7) !important" : "rgba(0,0,0,0.6) !important",
      fill: isDark ? "rgba(255,255,255,0.7) !important" : "rgba(0,0,0,0.6) !important",
    },
    "& .ct-grid": {
      stroke: isDark ? "rgba(255,255,255,0.1) !important" : "rgba(0,0,0,0.1) !important",
    },
  },

  // ── Control Bar ──
  controlBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "24px",
    padding: "16px 20px",
    background: isDark ? "linear-gradient(135deg, #1a1d23 0%, #23272f 100%)" : "#fff",
    borderRadius: "14px",
    border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.08)",
  },
  periodPills: {
    display: "flex",
    gap: "6px",
    flexWrap: "wrap",
  },
  pill: {
    padding: "7px 18px",
    borderRadius: "20px",
    border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.15)",
    background: "transparent",
    color: isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.55)",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 500,
    transition: "all 0.2s ease",
    "&:hover": {
      background: "rgba(99,102,241,0.12)",
      borderColor: "rgba(99,102,241,0.3)",
      color: "#818cf8",
    },
  },
  pillActive: {
    background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
    border: "1px solid #6366f1",
    color: isDark ? "#fff" : "#333",
    "&:hover": {
      background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
      color: isDark ? "#fff" : "#333",
    },
  },
  refreshBtn: {
    padding: "8px 20px",
    borderRadius: "10px",
    border: "1px solid rgba(99,102,241,0.3)",
    background: "rgba(99,102,241,0.08)",
    color: "#818cf8",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: "6px",
    transition: "all 0.2s ease",
    "&:hover": {
      background: "rgba(99,102,241,0.18)",
    },
  },

  // ── KPI Grid ──
  kpiGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "16px",
    marginBottom: "28px",
  },
  kpiCard: {
    background: isDark ? "linear-gradient(145deg, #1e2128 0%, #262a33 100%)" : "#fff",
    borderRadius: "14px",
    padding: "20px",
    border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.08)",
    transition: "all 0.25s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
      borderColor: "rgba(99,102,241,0.2)",
    },
  },
  kpiLabel: {
    fontSize: "12px",
    fontWeight: 500,
    color: isDark ? "rgba(255,255,255,0.45)" : "rgba(0,0,0,0.45)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "8px",
  },
  kpiValue: {
    fontSize: "28px",
    fontWeight: 700,
    color: isDark ? "#fff" : "#333",
    lineHeight: 1.1,
    marginBottom: "6px",
  },
  kpiChange: {
    fontSize: "12px",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    padding: "2px 8px",
    borderRadius: "6px",
  },
  kpiChangeUp: {
    color: "#34d399",
    background: "rgba(52,211,153,0.1)",
  },
  kpiChangeDown: {
    color: "#f87171",
    background: "rgba(248,113,113,0.1)",
  },

  // ── Widget Row ──
  widgetRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
    marginBottom: "28px",
    "@media (max-width: 960px)": {
      gridTemplateColumns: "1fr",
    },
  },
  widgetCard: {
    background: isDark ? "linear-gradient(145deg, #1e2128 0%, #262a33 100%)" : "#fff",
    borderRadius: "14px",
    padding: "24px",
    border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.08)",
  },
  widgetTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: isDark ? "#fff" : "#333",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  // ── Trend Chart ──
  chartScrollContainer: {
    width: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    paddingBottom: "6px",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: isDark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.03)",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: isDark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.18)",
      borderRadius: "4px",
      "&:hover": {
        background: isDark ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
      },
    },
  },
  chartContainer: {
    height: "220px",
    position: "relative",
  },
  chartCanvas: {
    width: "100%",
    height: "100%",
  },
  chartLegend: {
    display: "flex",
    gap: "20px",
    marginTop: "14px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12px",
    color: isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.55)",
  },
  legendDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    display: "inline-block",
  },

  // ── Funnel ──
  funnelContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0",
  },
  funnelStage: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "14px 0",
    borderBottom: isDark ? "1px solid rgba(255,255,255,0.04)" : "1px solid rgba(0,0,0,0.04)",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  funnelBar: {
    height: "36px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "14px",
    fontSize: "13px",
    fontWeight: 600,
    color: isDark ? "#fff" : "#333",
    transition: "width 0.6s cubic-bezier(0.4,0,0.2,1)",
    minWidth: "60px",
  },
  funnelLabel: {
    fontSize: "13px",
    color: isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.55)",
    minWidth: "90px",
    textAlign: "right",
  },
  funnelValue: {
    fontSize: "15px",
    fontWeight: 700,
    color: isDark ? "#fff" : "#333",
    minWidth: "50px",
  },
  funnelArrow: {
    color: "rgba(255,255,255,0.15)",
    fontSize: "18px",
    textAlign: "center",
    padding: "2px 0",
  },

  // ── Rewards Block ──
  rewardsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "14px",
  },
  rewardItem: {
    textAlign: "center",
    padding: "16px 10px",
    background: isDark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)",
    borderRadius: "10px",
    border: isDark ? "1px solid rgba(255,255,255,0.04)" : "1px solid rgba(0,0,0,0.04)",
  },
  rewardValue: {
    fontSize: "22px",
    fontWeight: 700,
    color: isDark ? "#fff" : "#333",
    marginBottom: "4px",
  },
  rewardLabel: {
    fontSize: "11px",
    color: isDark ? "rgba(255,255,255,0.45)" : "rgba(0,0,0,0.45)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },

  // ── Donut Chart ──
  donutWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "30px",
    flexWrap: "wrap",
  },
  donutSvg: {
    width: "160px",
    height: "160px",
  },
  donutCenter: {
    textAlign: "center",
  },
  donutTotal: {
    fontSize: "24px",
    fontWeight: 700,
    color: isDark ? "#fff" : "#333",
  },
  donutSubtitle: {
    fontSize: "11px",
    color: isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)",
  },
  donutLegend: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  donutLegendItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
  },
  donutLegendDot: {
    width: "10px",
    height: "10px",
    borderRadius: "3px",
    display: "inline-block",
  },

  // ── Summary Table ──
  summaryTableWrapper: {
    marginTop: "0",
  },
  summaryTable: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    background: isDark ? "linear-gradient(145deg, #1e2128 0%, #262a33 100%)" : "#fff",
    borderRadius: "14px",
    overflow: "hidden",
    border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.08)",
  },
  tableHead: {
    "& th": {
      padding: "14px 20px",
      fontSize: "11px",
      fontWeight: 600,
      color: isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)",
      textTransform: "uppercase",
      letterSpacing: "0.7px",
      borderBottom: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.06)",
      textAlign: "left",
    },
  },
  tableRow: {
    transition: "background 0.15s ease",
    "&:hover": {
      background: isDark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)",
    },
    "& td": {
      padding: "14px 20px",
      fontSize: "14px",
      color: isDark ? "rgba(255,255,255,0.8)" : "rgba(0,0,0,0.8)",
      borderBottom: isDark ? "1px solid rgba(255,255,255,0.03)" : "1px solid rgba(0,0,0,0.03)",
    },
  },
  metricIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    marginRight: "12px",
  },
  metricCell: {
    display: "flex",
    alignItems: "center",
  },
  statusBadge: {
    padding: "4px 12px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 600,
    background: "rgba(52,211,153,0.1)",
    color: "#34d399",
    display: "inline-block",
  },
  statusBadgeWarning: {
    background: "rgba(251,191,36,0.1)",
    color: "#fbbf24",
  },

  // ── Loading ──
  loadingOverlay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    color: isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)",
    fontSize: "15px",
  },
  shimmer: {
    background:
      "linear-gradient(90deg, rgba(255,255,255,0.02) 25%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.02) 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite",
    borderRadius: "10px",
    height: "120px",
  },

  // ── Tabs ──
  tabsContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: "24px",
    borderBottom: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.1)",
    paddingBottom: "10px",
  },
  tabButton: {
    padding: "10px 20px",
    background: "transparent",
    border: "none",
    color: isDark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    position: "relative",
    transition: "color 0.2s ease",
    "&:hover": {
      color: isDark ? "#fff" : "#333",
    },
  },
  tabButtonActive: {
    color: "#818cf8",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-11px",
      left: 0,
      width: "100%",
      height: "2px",
      background: "#818cf8",
      borderRadius: "2px 2px 0 0",
    },
  },

  // ── Availability Badges ──
  availBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px 6px",
    borderRadius: "4px",
    fontSize: "10px",
    fontWeight: "bold",
    marginLeft: "8px",
    verticalAlign: "middle",
  },
  availPartial: {
    background: "rgba(251,191,36,0.15)",
    color: "#fbbf24",
    border: "1px solid rgba(251,191,36,0.3)",
  },
  availEstimated: {
    background: "rgba(52,211,153,0.15)",
    color: "#34d399",
    border: "1px solid rgba(52,211,153,0.3)",
  },

  // ── Metadata Banner ──
  metaBanner: {
    background: "rgba(99,102,241,0.05)",
    border: "1px solid rgba(99,102,241,0.2)",
    borderRadius: "10px",
    padding: "12px 16px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    fontSize: "12px",
    color: isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
  },
  metaInfo: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  metaWarning: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#fbbf24",
    background: "rgba(251,191,36,0.1)",
    padding: "4px 10px",
    borderRadius: "6px",
  },

  // ── Provider Status Badges ──
  statusOk: {
    color: "#34d399",
    background: "rgba(52,211,153,0.1)",
  },
  statusPartial: {
    color: "#fbbf24",
    background: "rgba(251,191,36,0.1)",
  },
  statusStale: {
    color: "#f97316", // orange
    background: "rgba(249,115,22,0.1)",
  },
  statusError: {
    color: "#f87171", // red
    background: "rgba(248,113,113,0.1)",
  },
  statusDisabled: {
    color: isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)",
    background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
  },

  // ── Checkboxes (Multi-select) ──
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    fontSize: "13px",
    color: isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
    "&:hover": {
      color: isDark ? "#fff" : "#333",
    },
  },
  checkboxInput: {
    accentColor: "#6366f1",
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
  checkboxGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    padding: "16px",
    background: isDark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)",
    borderRadius: "10px",
    marginBottom: "20px",
  },

  // ── Inputs ──
  inputField: {
    background: isDark ? "rgba(255,255,255,0.05)" : "#fff",
    border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.2)",
    color: isDark ? "#fff" : "#333",
    padding: "6px 12px",
    borderRadius: "8px",
    outline: "none",
    "&:focus": {
      borderColor: "#6366f1",
      boxShadow: "0 0 0 2px rgba(99,102,241,0.2)",
    },
    "& option": {
      background: isDark ? "#1e2128" : "#fff",
      color: isDark ? "#fff" : "#333",
    }
  },
};
};

export default styles;
